import { ReactNode, useEffect, useRef } from 'react';
import './GradientDiv.css';

export const GradientDiv = ({ children }: { children: ReactNode }) => {
  const targetRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const updateMousePosition = (ev: MouseEvent) => {
      if (!targetRef.current) return;
      const { pageX, pageY } = ev; // changed from clientX/clientY
      targetRef.current.style.setProperty('--x', `${pageX}px`);
      targetRef.current.style.setProperty('--y', `${pageY}px`);
    };

    window.addEventListener('mousemove', updateMousePosition);

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
  }, []);

  return (
    <div ref={targetRef} className="gradient-mouse">
      {children}
    </div>
  );
};
